var map = {
	"./ATM.svg": "70bc",
	"./CashTodayUpdateCenterClaro.svg": "eb57",
	"./CashTodayUpdateCenterOscuro.svg": "2d56",
	"./administration.svg": "eb10",
	"./analytics.svg": "2f00",
	"./analytics_dark.svg": "20e5",
	"./bambu.svg": "6c7d",
	"./documents.svg": "b14e",
	"./export-icon.svg": "cdd6",
	"./firmas.svg": "5262",
	"./flujoProvision.png": "67eb",
	"./genkin.svg": "dafd",
	"./genkin_administration.svg": "5598",
	"./genkin_app.svg": "4163",
	"./header-background.jpg": "4e70",
	"./install-authenticator.svg": "6c80",
	"./logoProsegurCashFullBlanco.svg": "1c7a",
	"./logoprosegur.svg": "edf9",
	"./logoprosegurBlanco.svg": "4d61",
	"./miagencia_movil.svg": "6ea7",
	"./myprosegurapp.svg": "4027",
	"./orders.svg": "6973",
	"./portal_santander.svg": "8670",
	"./saldosonline.svg": "be44",
	"./transferencias.svg": "6cd9",
	"./user-management.svg": "31e5",
	"./videos.svg": "f5a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";